/**
 * Copyright (c) 2021, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
 * You may not alter or remove any copyright or other notice from copies of this content.
 */

import { AsgardeoAuthException, BasicUserInfo, SecureRoute, useAuthContext } from "@asgardeo/auth-react";
import React, { FunctionComponent, ReactElement } from "react";
import { RouteProps, useHistory } from "react-router-dom";
 
/**
 * Secure route with redirect  props interface.
 */
export type SecureRouteWithRedirectPropsInterface = RouteProps;

/**
 * Application secure route with redirect component.
 *
 * @param {SecureRouteWithRedirectPropsInterface} props - Props injected to the component.
 * @return {React.ReactElement}
 */
export const SecureRouteWithRedirect: FunctionComponent<SecureRouteWithRedirectPropsInterface> = (
    props: SecureRouteWithRedirectPropsInterface
): ReactElement => {

    const {
        component,
        path
    }= props;

    const history = useHistory();
    
    const { trySignInSilently, signIn } = useAuthContext();
    
    /**
     * callback fucntion for the redirect path
     */
    const callback = () => {
        trySignInSilently()
            .then((response: boolean | BasicUserInfo) => {
                if (!response) {
                    signIn();
                }
            })
            .catch((error: AsgardeoAuthException) => {
                if (error?.code === "SPA-AUTH_HELPER-SI-SE01") {
                    history.push({
                        pathname: "error",
                        search: `?error_description=${ error.message }`
                    });
                }
            });
    };

    return (
        <SecureRoute
            exact
            path={ path }
            component={ component }
            callback={ callback }
        />
    );
};
